import { render, staticRenderFns } from "./bilibili_video_comments.vue?vue&type=template&id=511aa3cb"
import script from "./bilibili_video_comments.vue?vue&type=script&lang=js"
export * from "./bilibili_video_comments.vue?vue&type=script&lang=js"
import style0 from "./bilibili_video_comments.vue?vue&type=style&index=0&id=511aa3cb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports